import ProductSelector from "components/EvtKit/ProductSelector"
import Heading from "components/Typography/Heading"
import { memo, useCallback } from "react"
import styled from "styled-components"
import WebhookBoard from "./WebhookBoard"
import CreateWebhookButton from "./CreateWebhookButton"

const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 24px 0;
`
const ProductContainer = styled.div`
  display: flex;
  width: 320px;
`

const ButtonContainer = styled.div`
  margin-right: 24px;
`

interface Props {
  hasData: boolean
  filterValue: string
  setFilterValue: (value: string) => void
}

const WebhooksHeader = (props: Props) => {
  const { hasData, filterValue, setFilterValue } = props

  const handleSelectChange = useCallback((productValue) => {
    if (!productValue) {
      setFilterValue("")

      return
    }
    setFilterValue(productValue)
  }, [])

  return (
    <>
      <ContainerTitle>
        <Heading variant="h3">Webhooks</Heading>
        {hasData && (
          <ButtonContainer>
            <CreateWebhookButton title="Criar Webhook" />
          </ButtonContainer>
        )}
      </ContainerTitle>
      <SelectContainer>
        <ProductContainer>
          <ProductSelector onChange={handleSelectChange} value={filterValue} label="Filtrar por produto" cleanFilter />
        </ProductContainer>
      </SelectContainer>
      {!hasData && <WebhookBoard filterValue={filterValue} />}
    </>
  )
}

export default memo(WebhooksHeader)
